import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import ContentEdit, { Header, Detail, Side } from './ContentEdit';

import {
  JobFilters,
  JobCards,
  JobDetail,
  JobCardsSide,
} from './Jobs';

import { startEditAdmin } from '../../store/actions/admin';

const styles = theme => ({
  root: {
  },
  cardsView: {
    marginTop: theme.spacing.unit,
    marginRight: theme.spacing.unit*4,
    marginBottom: theme.spacing.unit*4,
    marginLeft: theme.spacing.unit*4,
  }
});

const JobsPage = (props) => {
  const {
    classes,
    project,
    theme,
  } = props;

  return (
    <div className={classes.root}>
      {project &&
        <JobDetail />
      }
      {!project &&
        <div className={classes.cardsView}>
          <ContentEdit>
            <Header theme={theme}>
              <JobFilters />
            </Header>
            <Detail theme={theme}>
              <JobCards />
            </Detail>
            <Side theme={theme}>
              <JobCardsSide />
            </Side>
          </ContentEdit>
        </div>
      }
    </div>
  );
}

JobsPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return ({
    invoice: state.adminState.invoice,
    project: state.adminState.project,
  });
};

const mapDispatchToProps = (dispatch) => ({
  startEditAdmin: (invoice) => dispatch(startEditAdmin(invoice)),
});

export default compose(
  withStyles(styles, { withTheme: true }),
  connect(mapStateToProps, mapDispatchToProps),
)(JobsPage);



// WEBPACK FOOTER //
// ./src/components/admin/JobsPage.jsx